const UPDATE_NAV_SIDEBAR_VISIBILITY = 'src/navSideBar/UPDATE_NAV_SIDEBAR_VISIBILITY';

export default {
  UPDATE_NAV_SIDEBAR_VISIBILITY
};
